import React from 'react';
import { Target, Users, TrendingUp, Award } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-[var(--bg-page)]">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="heading-1 mb-4">About Infiniti Health</h2>
          <p className="body-large text-[var(--text-secondary)]">
            We are a healthcare support company dedicated to bridging operational gaps between hospital billing, insurance processes, and patient financial support.
          </p>
        </div>

        {/* Mission Statement */}
        <div className="bg-white rounded-2xl p-8 md:p-12 mb-12 shadow-sm">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-[var(--accent-blue-200)] rounded-full px-4 py-2 mb-4">
                <Target className="w-4 h-4 text-[var(--brand-blue)]" />
                <span className="text-xs font-medium text-[var(--text-primary)] uppercase tracking-wide">
                  Our Mission
                </span>
              </div>
              <h3 className="heading-2 mb-4">Enabling Smoother Claims & Reduced Financial Burden</h3>
              <p className="body-medium text-[var(--text-secondary)]">
                Infiniti Health helps hospitals and patients manage treatment access and insurance-claim journeys, while reducing out-of-pocket expenses—especially in situations where cashless access is missing or the process is poorly managed.
              </p>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 bg-[var(--accent-green-200)] rounded-lg">
                <Users className="w-6 h-6 text-[var(--brand-green)] flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">Patient-Centric</h4>
                  <p className="body-small text-[var(--text-secondary)]">Focused on reducing patient out-of-pocket expenses</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 bg-[var(--accent-blue-200)] rounded-lg">
                <TrendingUp className="w-6 h-6 text-[var(--brand-blue)] flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">Hospital Support</h4>
                  <p className="body-small text-[var(--text-secondary)]">Value-added desk operations and workflow management</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 bg-[var(--accent-pink-200)] rounded-lg">
                <Award className="w-6 h-6 text-[var(--brand-blue)] flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">Structured Process</h4>
                  <p className="body-small text-[var(--text-secondary)]">Compliant and verified financing solutions</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Value Proposition */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-[var(--accent-blue-200)] rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl font-bold text-[var(--brand-blue)]">1</span>
            </div>
            <h3 className="heading-3 mb-3">Cashless Workflow Setup</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Setting up or managing cashless desk operations for hospitals, including those lacking a structured workflow.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-[var(--accent-green-200)] rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl font-bold text-[var(--brand-green)]">2</span>
            </div>
            <h3 className="heading-3 mb-3">Insurance Gap Resolution</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Supporting cases where hospitals aren't empaneled with patient insurers, avoiding unnecessary upfront payments.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-[var(--accent-pink-200)] rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl font-bold text-[var(--brand-blue)]">3</span>
            </div>
            <h3 className="heading-3 mb-3">End-to-End Support</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Complete assistance from documentation to claim follow-up, with structured financing through partnered NBFCs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
